<template>
  <nav class="collapse" :class="{ show: show }" id="main-menu">
    <div class="cv-fullwidth">
      <div class="row no-gutters justify-content-md-center align-items-center cv-fullheight">
        <div class="col-12">
          <div class="container">
            <div class="row justify-content-md-center">
              <div class="col col-lg-3">
                <ul class="list-unstyled">
                  <li>
                    <a href="https://leap.510.ventures" :class="{ active: site === 'leap' }">
                      <span>Leap</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://team.510.ventures" :class="{ active: site === 'team' }">
                      <span>Team</span>
                    </a>
                  </li>
                  <!-- <li><a href="#"><span>Use Cases</span></a></li>
                  <li><a href="#"><span>Media</span></a></li>
                  <li><a href="#"><span>Partners</span></a></li>-->
                </ul>
              </div>

              <div class="col-12 col-lg-3">
                <ul class="list-unstyled">
                  <li>
                    <a href="https://lab15.510.ventures" :class="{ active: site === 'lab' }">
                      <span>Lab</span>
                      <p>Research & Tech Development</p>
                    </a>
                  </li>
                </ul>
              </div>

              <div class="col-12 col-lg-3">
                <ul class="list-unstyled">
                  <li>
                    <a href="https://elements.510.ventures" :class="{ active: site === 'elements' }">
                      <span>Element(s)</span>
                      <p>Digital Ecosystems</p>
                    </a>
                  </li>
                  <!-- <li>
												<a href="#">
													<span>OS</span>
													<p>Company Operating System</p>
												</a>
											</li>
											<li>
												<a href="#">
													<span>Core</span>
													<p>Open Development Tool</p>
												</a>
											</li>
											<li>
												<a href="#">
													<span>Edge</span>
													<p>Gateway Empowered Edge</p>
												</a>
                  </li>-->
                </ul>
              </div>

              <div class="col-12 col-lg-3">
                <ul class="list-unstyled">
                  <li>
                    <a href="https://investments.510.ventures" :class="{ active: site === 'investments' && route.path != '/rwanda' }">
                      <span>Investments</span>
                      <p>Digital Catalyst</p>
                    </a>
                    <ul class="list-unstyled">
                      <li>
                        <a href="https://investments.510.ventures/rwanda" :class="{ active: site === 'investments' && route.path === '/rwanda' }">
                          <span>Rwanda</span>
                          <p>Digital Implementation</p>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- /menu -->
    </div>
  </nav>
</template>

<script>
import { global } from '../../mixins/global';

export default {
  name: 'nav-menu',
  mixins: [global],
  data() {
    return {
      route: {}
    };
  },
  mounted() {
    console.log('test', this.$route);
    this.route = this.$route;
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>
